export const validateEmail = (email) => {
  // Basic email regex pattern - updated to include + character for email aliasing
  const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};

export const validatePassword = (password) => {
  const minLength = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar =
    /^(?!\s)(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])(?!.*\s$).+$/.test(
      password
    );

  return (
    minLength && hasNumber && hasUpperCase && hasLowerCase && hasSpecialChar
  );
};
